import React, { Component } from 'react'
import { SingleDatePicker } from 'react-dates'
import moment from 'moment'
import { breakpoints } from '../../../constants/breakpoints.constants'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import './react_dates_overrides.scss'

export class LightDatePicker extends Component {
	constructor(props) {
		super(props)
	}

	handleFocusChange = ({ focused }) => {
		const { onFocusChange } = this.props
		onFocusChange(focused)
	}

	render() {
		const {
			placeholder,
			date,
			onDateChange,
			focused,
			id,
			numberOfMonths,
			disabled,
			isOutsideRange,
			daySize,
			verticalSpacing,
			withPortal,
			showClearDate
		} = this.props

		return (
			<SingleDatePicker
				daySize={daySize || 40}
				verticalSpacing={verticalSpacing || 0}
				noBorder
				readOnly
				block
				showClearDate={showClearDate != undefined ? showClearDate : true}
				withPortal={withPortal || false}
				inputIconPosition="after"
				displayFormat="DD/MM/YYYY"
				hideKeyboardShortcutsPanel={true}
				numberOfMonths={numberOfMonths || 1}
				id={id} // Obrigatório
				date={date} // Obrigatório (moment() ou null)
				focused={focused} // Obrigatório (bool)
				disabled={disabled}
				onDateChange={onDateChange} // Obrigatório
				isOutsideRange={isOutsideRange}
				onFocusChange={this.handleFocusChange} // Obrigatório
				placeholder={placeholder || 'Selecione...'}
			/>
		)
	}
}
